/**
 * 后台的明暗主题。
 *
 * 换的只有明暗,不换品牌:两个主题都是 vg-studio(金色),`vg-studio` 是暗、`vg-studio-light` 是亮。
 * 切到 `@drama/ui` 默认那套紫色亮色主题的话,同一个后台上午金色下午紫色,人会以为进错了系统。
 *
 * **这个 ref 是主题的唯一事实源。** 颜色本身在 CSS 里(`data-theme` 一换,所有 `var(--drama-*)` 跟着
 * 变,组件零改动),但 **ECharts 的 option 是一次算出来的 JS 对象** —— 它不认 CSS 变量,主题变了
 * 得有人叫它重算。图表组件把这个 ref 读进 `computed`,切换才会重画(见 `chart-theme.js`)。
 *
 * 初值:上次选的 → 没选过就跟系统(`prefers-color-scheme`)→ 都拿不到就暗色。
 */
import { readonly, ref } from 'vue'

export const THEME_DARK = 'vg-studio'
export const THEME_LIGHT = 'vg-studio-light'

const STORAGE_KEY = 'vga-admin-theme'

const theme = ref(THEME_DARK)

/** 应用一次主题:写 DOM(CSS 认这个)+ 写 ref(JS 认这个)。 */
function apply(next) {
  theme.value = next
  document.documentElement.dataset.theme = next
}

/** 没选过就跟系统。选过就一直是他选的 —— 系统主题随日落自己变,后台不该跟着跳。 */
function initialTheme() {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved === THEME_DARK || saved === THEME_LIGHT) return saved
  return window.matchMedia?.('(prefers-color-scheme: light)').matches ? THEME_LIGHT : THEME_DARK
}

/** 在 `main.js` 里调一次,把初始主题落到 DOM 上。 */
export function installAdminTheme() {
  apply(initialTheme())
}

export function useAdminTheme() {
  return {
    theme: readonly(theme),
    isDark: () => theme.value === THEME_DARK,
    toggle() {
      const next = theme.value === THEME_DARK ? THEME_LIGHT : THEME_DARK
      apply(next)
      localStorage.setItem(STORAGE_KEY, next)
    },
  }
}
